(function(){
  const selectors = [
    '.plm-price-card',
    '.plm-mini-timer__value'
  ];

  function addRing(el, index){
    if (!el || el.dataset.plmV32Ring === '1') return;
    el.dataset.plmV32Ring = '1';
    el.classList.add('plm-v32-glow-case');
    const ring = document.createElement('span');
    ring.className = 'plm-v32-glow-ring';
    ring.setAttribute('aria-hidden','true');
    ring.style.setProperty('--plm-v32-delay', `${-(index % 7) * 0.42}s`);
    ring.style.setProperty('--plm-v32-speed', `${4.2 + (index % 4) * 0.28}s`);
    el.appendChild(ring);
  }

  function init(){
    let index = 0;
    document.querySelectorAll(selectors.join(',')).forEach((el)=>addRing(el,index++));
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
  document.addEventListener('shopify:section:load',init);
})();
